<template>
    <div>
        <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
                <validation-observer v-slot="{ invalid, handleSubmit }" ref="emailValidator">
                    <form role="form" @submit.prevent="handleSubmit(submit)">

                        <base-input alternative
                            name="email"
                            :rules="{required: true, email: true}"
                            prepend-icon="tim-icons icon-mail"
                            :placeholder="$t('auth.email-placeholder')"
                            v-model="form.email"
                            class="mb-3"
                        >
                        </base-input>

                        <p class="error mb-3 text-center" v-if="error">
                            {{ error }}
                        </p>
                        
                        <div class="text-center pt-2">
                            <base-button type="primary"
                                native-type="submit"
                                :disabled="invalid || sent"
                                :loading="sending"
                            >
                                {{ $t('auth.send-reset-link') }}
                            </base-button>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <router-link to="/astral/ui/login" class="text-light">
                    <small>{{ $t('auth.know-my-password') }}</small>
                </router-link>
            </div>
            <div class="col-6 text-right">
                <a href="mailto:astral@enac.fr" class="text-light">
                    <small>{{ $t('common.contact') }}</small>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                form: {
                    email: null,
                },
                sending: false,
                sent: false,
                error: null
            }
        },

        methods: {
            submit() {
                this.sending = true
                this.error = null;
                axios.post('/trax/api/auth/password/email', this.form)
                    .then(resp => {
                        this.sending = false
                        this.sent = true
                        this.$notify({type: 'success', message: this.$t('auth.reset-link-sent') })
                    })
                    .catch(err => {
                        this.sending = false
                        if (err.response.status == 422) {
                            this.error = err.response.data.errors.email[0]
                        } else if (err.response.status == 403) {
                            this.error = this.$t('auth.reset-link-error-403')
                        } else if (err.response.status == 500) {
                            this.error = this.$t('auth.reset-link-error-500')
                        } else {
                            this.error = err.response.data.message
                        }
                    });
            }
        }
    }
</script>

<style scoped>

    .error {
        font-size: 80%;
        color: #fb6340;
        font-weight: 400;
    }

</style>
